import script from "./PaymentableDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentableDetail.vue?vue&type=script&setup=true&lang=js"

import "./PaymentableDetail.vue?vue&type=style&index=0&id=acf2e27a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acf2e27a"]])

export default __exports__